import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PORTFOLIO } from "../data/content";
import Reveal from "../components/Reveal";
import Seo from "../components/Seo";

export default function Portfolio() {
  return (
    <div data-testid="page-portfolio">
      <Seo
        title="Client Work — Real Businesses, Real Engagements"
        description="Selected Mogul Group Advisors engagements across hospitality, retail, restoration, wellness, and home services in Dallas–Fort Worth."
        path="/portfolio"
      />

      <section className="bg-white pt-20 pb-10">
        <div className="container-wide max-w-4xl">
          <div className="overline mb-6">Client Work</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]" data-testid="portfolio-headline">
            Real businesses. Real engagements.
          </h1>
          <p className="mt-6 text-lg text-[#4B5563] leading-relaxed">
            A selection of businesses we've worked with across hospitality, home services, restoration, wellness, and specialty retail. Each engagement is tailored to the operator's real challenges — not a template.
          </p>
        </div>
      </section>

      <section className="bg-[#F7F7F8]">
        <div className="container-wide py-16 md:py-24 space-y-12">
          {PORTFOLIO.map((p, i) => (
            <Reveal key={p.slug}>
              <article className={`grid md:grid-cols-12 gap-8 items-center bg-white border border-gray-100`} data-testid={`portfolio-item-${p.slug}`}>
                <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                  <img src={p.image} alt={`${p.name} — ${p.category}`} className="w-full h-80 md:h-96 object-cover" />
                </div>
                <div className={`md:col-span-7 p-8 md:p-12 ${i % 2 === 1 ? "md:order-1" : ""}`}>
                  <div className="overline mb-3">{p.category}</div>
                  <h2 className="font-serif text-2xl md:text-3xl tracking-tight leading-tight">{p.name}</h2>
                  <div className="mt-6 space-y-4 text-sm">
                    <div>
                      <div className="text-[10px] uppercase tracking-widest text-gold mb-1">Problem</div>
                      <p className="text-[#4B5563] leading-relaxed">{p.problem}</p>
                    </div>
                    <div>
                      <div className="text-[10px] uppercase tracking-widest text-gold mb-1">Work</div>
                      <p className="text-[#4B5563] leading-relaxed">{p.work}</p>
                    </div>
                    <div>
                      <div className="text-[10px] uppercase tracking-widest text-gold mb-1">Result</div>
                      <p className="text-[#4B5563] leading-relaxed">{p.result}</p>
                    </div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}

          <p className="text-xs text-[#6B7280] italic max-w-3xl">
            Case-study details are shared with each client's permission. Additional projects, imagery, and measured outcomes are added as they become available for public release.
          </p>
        </div>
      </section>

      <section className="bg-[#0A0A0A] text-white">
        <div className="container-wide py-20 text-center max-w-3xl mx-auto">
          <h2 className="font-serif text-3xl md:text-4xl leading-tight">Ready to see what a real engagement looks like for your business?</h2>
          <div className="mt-8 flex gap-4 justify-center flex-wrap">
            <Link to="/growth-assessment" className="btn btn-primary" data-testid="portfolio-cta-ga">Get Your Free Growth Assessment <ArrowRight className="w-4 h-4" strokeWidth={1.5} /></Link>
            <Link to="/contact" className="btn btn-dark" data-testid="portfolio-cta-contact">Schedule a Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
